import { render, staticRenderFns } from "./Sm600White.vue?vue&type=template&id=32f85840&scoped=true&"
var script = {}
import style0 from "./Sm600White.vue?vue&type=style&index=0&id=32f85840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f85840",
  null
  
)

export default component.exports